import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lsh_lang") || "it");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("lsh_lang", l);
  }, []);

  const t = useCallback((key) => {
    return (translations[lang] && translations[lang][key]) || translations.it[key] || key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
